import { permissionCreate } from '@permissions';

const markTodoItem = permissionCreate('TIME_LINE_MARK_TODO_ITEM');

export const TIMELINE = {
  [markTodoItem]: markTodoItem,
};

export default TIMELINE;
